import React from "react";
import RecyclingSidebar from "../components/RecyclingSidebar";
import RecyclingDetections from "../components/RecyclingDetections";

const RecyclingDetectionsPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <RecyclingSidebar />
      <RecyclingDetections />
    </div>
  );
};

export default RecyclingDetectionsPage;
